// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"c9104b97","847":"80d3c8c2","861":"52e5ea9c","884":"b055277b"}[chunkId] + ".css";
};